export default class RecentlyCodesPlus extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps){
     const currentMethod = this.props.historyCodes.currentMethod;
     const _currentMethod = nextProps.historyCodes.currentMethod;
     if (!currentMethod || !_currentMethod) {return;}
     if (currentMethod.menuid != _currentMethod.menuid) {
      // 切换玩法的时候置顶
      document.querySelector('#history-codes' ).scrollTop = 0
     }
  }

  render() {
    if (!this.props.historyCodes) {return (<div />);}
    const {currentMethod, history, title} = this.props.historyCodes;
    return (
      <div className='recently-codes-plus-container'>
        <div className='content'>
        	<h3>
        		<span>近期开奖</span>
        	</h3>
          <h2>
            <span className={title ? 'issue' : 'issue full-size'}>期号</span>
            <span className={title ? 'codes' : 'codes full-size'}>开奖号码</span>
            {
              title && <span className='form'>{title}</span>
            }
          </h2>
          <div className='history-codes' id='history-codes'>
            {
              (history && history.length > 0) &&
              history.map((history_item, index) => 
                <div className='history-code-item' key={index} style={{display: index <= 11 ? 'block' : 'none'}}>
                  <div className={title ? (history_item.issueClass + ' code-issue') : (history_item.issueClass + ' code-issue full-size')}>{history_item.issue}期</div>
                  <div className={title ? 'code-number' : 'code-number full-size'}>
                    {
                      history_item.codes.map((history, key) => <span className={history.className} key={key}>{history.codes || '-'}</span>)
                    }
                  </div>
                  {
                    title &&
                    <div className='code-form'>
                      {
                        history_item.form.map((_form, key) => <span className={_form.className} key={key}>{_form.label}</span>)
                      }
                    </div>
                  }
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}